// src/api/axios.js
import axios from 'axios';

// Tomamos la URL del backend desde las variables de entorno
const baseURL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : 'http://localhost:3001/api'; // fallback por si falta la variable

const API = axios.create({ baseURL });

// ✅ Interceptor GLOBAL: inyecta el token JWT en TODAS las peticiones
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default API;

